import {createStore} from 'vuex'
import connection from './modules/connection';
import auth from './modules/auth';
import i18n from './modules/i18n';
import theme from './modules/theme';
import errorLabel from './modules/errorLabel';
import agent from './modules/agent';
import backups from './modules/backups';
import blockchains from './modules/blockchains';
import blockchain from './modules/blockchain';
import blockchainAddresses from './modules/blockchainAddresses';
import currency from './modules/currency';
import currencies from './modules/currencies';
import exchange from './modules/exchange';
import exchangeCurrencies from './modules/exchangeCurrencies';
import exchangePairs from './modules/exchangePairs';
import exchanges from './modules/exchanges';
import indicator from './modules/indicator';
import indicatorParams from './modules/indicatorParams';
import indicatorOuts from './modules/indicatorOuts';
import indicatorSets from './modules/indicatorSets';
import indicators from './modules/indicators';
import languages from './modules/languages';
import globalCurrencies from './modules/globalCurrencies';
import globalPairs from './modules/globalPairs';
import globalPair from './modules/globalPair';
import globalPairExchanges from './modules/globalPairExchanges';
import globalPairIndicatorSets from './modules/globalPairIndicatorSets';
import settings from './modules/settings';
import tradeGroups from './modules/tradeGroups';
import userAgent from './modules/userAgent';
import userAccount from './modules/userAccount';
import userTelegramConnection from './modules/userTelegramConnection';
import userTelegramConnectionEvent from './modules/userTelegramConnectionEvent';
import userWallet from './modules/userWallet';
import users from './modules/users';
import computedData from './modules/computedData';
import admin from './modules/admin';
import language from './modules/language';
import locales from './modules/locales';
import countries from './modules/countries';
import countryLanguages from './modules/countryLanguages';
import country from './modules/country';
import recommendedLanguages from './modules/recommendedLanguages';
import currencyBlockchains from './modules/currencyBlockchains';
import actions from './modules/actions';
import action from './modules/action';
import actionErrors from './modules/actionErrors';
import actionError from './modules/actionError';
import emailTemplates from './modules/emailTemplates';
import emailTemplate from './modules/emailTemplate';
import languageEntities from './modules/languageEntities';
import languageEntity from './modules/languageEntity';
import languageGroups from './modules/languageGroups';
import languageGroup from './modules/languageGroup';
import languageGroupItems from './modules/languageGroupItems';
import languageGroupItem from './modules/languageGroupItem';
import languagePages from './modules/languagePages';
import languagePage from './modules/languagePage';
import languagePageItems from './modules/languagePageItems';
import languagePageItem from './modules/languagePageItem';
import translateLanguagePages from './modules/translateLanguagePages';
import translateEmailTemplates from './modules/translateEmailTemplates';
import translateLanguageEntities from './modules/translateLanguageEntities';
import translateActionErrors from './modules/translateActionErrors';
import translateLanguageGroupItems from './modules/translateLanguageGroupItems';
import translateLanguagePageItems from './modules/translateLanguagePageItems';
import priceCurrencies from './modules/priceCurrencies';
import priceExchanges from './modules/priceExchanges';
import pricePairs from './modules/pricePairs';
import priceExchange from './modules/priceExchange';
import graph from './modules/graph';
import pageState from './modules/pageState';

export interface RootState {
  [key: string]: any;
}

export default createStore({
  modules: {
    connection,
    auth,
    i18n,
    theme,
    errorLabel,
    agent,
    backups,
    blockchains,
    blockchain,
    blockchainAddresses,
    currency,
    currencies,
    exchange,
    exchangeCurrencies,
    exchangePairs,
    exchanges,
    indicator,
    indicatorParams,
    indicatorOuts,
    indicatorSets,
    indicators,
    languages,
    globalCurrencies,
    globalPairs,
    globalPair,
    globalPairExchanges,
    globalPairIndicatorSets,
    settings,
    tradeGroups,
    users,
    userAgent,
    userAccount,
    userTelegramConnection,
    userTelegramConnectionEvent,
    userWallet,
    computedData,
    admin,
    language,
    locales,
    countries,
    countryLanguages,
    country,
    recommendedLanguages,
    currencyBlockchains,
    actions,
    action,
    actionErrors,
    actionError,
    emailTemplates,
    emailTemplate,
    languageEntities,
    languageEntity,
    languageGroups,
    languageGroup,
    languageGroupItems,
    languageGroupItem,
    languagePages,
    languagePage,
    languagePageItems,
    languagePageItem,
    translateLanguagePages,
    translateEmailTemplates,
    translateLanguageEntities,
    translateActionErrors,
    translateLanguageGroupItems,
    translateLanguagePageItems,
    priceCurrencies,
    priceExchanges,
    pricePairs,
    priceExchange,
    graph,
    pageState,
  },
})
